<nb-card>
	<nb-card-body class="overflow-visible">
		<form [formGroup]="form">
			<div class="form-row margin-bottom20">
				<div class="form-input">
					<label class="company-input-label label-row">{{ 'company-address.name' | translate }}</label>
					<input type="text" name="company" nbInput [placeholder]="'company-address.name-placeholder' | translate" fullWidth formControlName="companyName"
						   autocomplete="user-password">
					@if (isInvalid('companyName')) {
						<div class="validation-message">{{ getValidationErrors('companyName') | async }}</div>
					}
				</div>
			</div>
			<div class="form-row margin-bottom20">
				<div class="form-input">
					<div class="audit-date-label-flex">
						<label class="company-input-label label-row float-left">{{ 'company-address.street' | translate }}</label>
					</div>
					<input name="address-street" type="text" nbInput [placeholder]="'company-address.street-placeholder' | translate" formControlName="street" fullWidth
						   autocomplete="user-password">
					@if (isInvalid('street')) {
						<div class="validation-message">{{ getValidationErrors('street') | async }}</div>
					}
				</div>
				<div class="form-input">
					<div class="audit-date-label-flex">
						<label class="company-input-label label-row float-left">{{ 'company-address.city' | translate }}</label>
					</div>
					<input name="address-city" type="text" nbInput [placeholder]="'company-address.city-placeholder' | translate" formControlName="city" fullWidth
						   autocomplete="user-password">
					@if (isInvalid('city')) {
						<div class="validation-message">{{ getValidationErrors('city') | async }}</div>
					}
				</div>
			</div>
			<div class="form-row grouped-inputs">
				<div class="form-input country-input">
					<label class="company-input-label label-row">{{ 'company-address.country' | translate }}</label>
					<ng-select [items]="stringCountries" [notFoundText]="'common.not-found' | translate" labelForId="address-state"
							   [inputAttrs]="{autocomplete: 'user-password'}" [clearable]="false"
							   [dropdownPosition]="'bottom'" formControlName="country"></ng-select>
					@if (isInvalid('country')) {
						<div class="validation-message">{{ getValidationErrors('country') | async }}</div>
					}
				</div>
				<div class="form-input state-input">
					<label class="company-input-label label-row">{{ 'company-address.state' | translate }}</label>
					<ng-select [items]="selectedCountry.code === 'PL' ? (selectedCountry.administrativeDivisions) : (selectedCountry.administrativeDivisions | sortBy: 'asc')"
							   labelForId="address-state"
							   [inputAttrs]="{autocomplete: 'user-password'}" [clearable]="false" [notFoundText]="'common.not-found' | translate"
							   [dropdownPosition]="'bottom'" [placeholder]="'company-address.state-placeholder' | translate" formControlName="usState"></ng-select>
					@if (isInvalid('usState')) {
						<div class="validation-message">{{ getValidationErrors('usState') | async }}</div>
					}
				</div>
				<div class="form-input">
					<div class="audit-date-label-flex">
						<label class="company-input-label label-row float-left">{{ 'company-address.zip' | translate }}</label>
					</div>
					<input name="address-zip-code" [type]="usSelected ? 'tel' : 'text'" nbInput placeholder="{{placeholderText}}" formControlName="zipCode" fullWidth
						   autocomplete="user-password" (keyup)="correctZipCode()">
					@if (isInvalid('zipCode')) {
						<div class="validation-message">{{ getValidationErrors('zipCode') | async }}</div>
					}
				</div>
			</div>
			<div class="additional-fields">
				@if (includeTaxId() | async) {
					<div class="form-row">
						<div class="form-input">
							<label class="company-input-label label-row">{{ 'company-address.taxId' | translate }}</label>
							<input name="taxId" fullWidth nbInput type="text" placeholder="{{'company-address.taxId-placeholder.' + selectedCountry.code | translate}}" formControlName="taxId">
							@if (isInvalid('taxId')) {
								<div class="validation-message">{{ getValidationErrors('taxId') | async }}</div>
							}
						</div>
					</div>
				}

				@if (includeKvkNr() | async) {
					<div class="form-row">
						<div class="form-input">
							<label class="company-input-label label-row">{{ 'company-address.kvkNr' | translate }}</label>
							<input name="kvkNr" fullWidth nbInput type="text" placeholder="{{'company-address.kvkNr-placeholder.' + selectedCountry.code | translate}}" formControlName="kvkNr">
							@if (isInvalid('kvkNr')) {
								<div class="validation-message">{{ getValidationErrors('kvkNr') | async }}</div>
							}
						</div>
					</div>
				}
			</div>
		</form>
	</nb-card-body>
</nb-card>
